/*
 * NextGenn engine · back to the top (snippets/ngs-to-top.liquid).
 * Appears after two screens, goes away at the top. Read once a frame at most:
 * a scroll handler that measures on every event is how a phone loses its
 * smoothness.
 */
if (!customElements.get('ngs-to-top')) {
  customElements.define(
    'ngs-to-top',
    class NGSToTop extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.hidden = false;
        this.onScroll = this.scrolled.bind(this);
        this.onClick = this.toTop.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.button.addEventListener('click', this.onClick);
        this.gauge();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.button) this.button.removeEventListener('click', this.onClick);
      }

      scrolled() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(
          function () {
            this.ticking = false;
            this.gauge();
          }.bind(this)
        );
      }

      gauge() {
        var seen = window.innerHeight || document.documentElement.clientHeight;
        this.toggleAttribute('data-on', window.scrollY > seen * 2);
      }

      toTop() {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      }
    }
  );
}
